module.exports = __webpack_public_path__ + "static/media/Questions-bro1.2cf75d96.svg";